import React, { useState } from "react";
import Button from "../../components/Button/index";
import { IconInterfacesLock } from "../../components/IconInterfacesLock";
import { TypeForm } from "../../components/TypeForm/index";
import "./style.css";
import Logo from "../../components/Logo/Logo";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { isCodiceFiscale } from "../../utils/utils";
import ErrorMessageInForm from "../../components/ErrorMessageInForm/index";

import { useDispatch } from "react-redux";
import { setIsLoading, setMultifactorError } from "../../store/slices/main";
import { saveSession } from "../../utils/auth/session";
import { client } from "../../lib/axios";
import { AVAILABLE_PROVINCIE } from "../../constants/vetrina/Other";
import { reportError } from "../../lib/errorReporting";

export const SignInPage = () => {
  const [codiceFiscale, setCodiceFiscale] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const auth = getAuth();

  const dr = useDispatch();

  const handleClickLoginButton = async () => {
    setErrorMessage("");

    if (!isCodiceFiscale(codiceFiscale)) {
      setErrorMessage("Inserisci un codice fiscale valido");
      return;
    }

    if (password.length === 0) {
      setErrorMessage("Inserisci la password");
      return;
    }

    // Preserve the exact password from the click event. Do not trim,
    // normalize, change case, or otherwise transform credentials.
    const submittedPassword = password;

    dr(setIsLoading(true));

    try {
      const result = await client.post("/auth/check-associato", {
        codiceFiscale,
      });

      if (!result.data.active) {
        setErrorMessage(
          "Il servizio di ricerca e selezione è riservato ai soli associati."
        );
        return;
      }

      const userData = result.data.user;

      if (!userData) {
        setErrorMessage("Utente non risulta registrato");
        return;
      }

      const email = userData.email?.toLowerCase();

      if (!email) {
        setErrorMessage("Email utente mancante. Contatta l'assistenza.");
        return;
      }

      await signInWithEmailAndPassword(auth, email, submittedPassword);
      await saveSession({ codiceFiscale });

      const provincia = userData.provincia;
      navigate(
        AVAILABLE_PROVINCIE.includes(provincia)
          ? `/vetrina?provincia=${encodeURIComponent(provincia)}`
          : "/arriving-soon",
        { replace: true }
      );
    } catch (error) {
      await reportError(error, { operation: "auth.family.signInFlow" });
      console.log(error);

      if (error.message?.includes("(auth/multi-factor-auth-required)")) {
        dr(setMultifactorError(error));
        const searchParams = new URLSearchParams(window.location.search);
        const from = searchParams.get("from") || "/vetrina";
        navigate(
          `/r/impl-2fa?cf=${codiceFiscale}&code=true&from=${encodeURIComponent(
            from
          )}`,
          { replace: false }
        );
        return;
      }

      const errorCode = error.code || "";
      const errorText = `${errorCode} ${error.message || ""}`;
      let message = "Si è verificato un errore, per favore riprova.";

      if (
        errorText.includes("invalid-login-credentials") ||
        errorText.includes("invalid-credential") ||
        errorText.includes("wrong-password") ||
        errorText.includes("user-not-found")
      ) {
        message = "Credenziali errate, per favore riprova.";
      } else if (errorText.includes("user-disabled")) {
        message = "Utente disabilitato. Contatta l'assistenza.";
      } else if (errorText.includes("too-many-requests")) {
        message = "Troppi tentativi non riusciti. Riprova più tardi.";
      } else if (error.response?.data?.message) {
        message = error.response.data.message;
      }

      setErrorMessage(message);
    } finally {
      dr(setIsLoading(false));
    }
  };

  const forgetPassword = (value) => {
    navigate("/password-dimenticata", { replace: true }); // Move to Home page
  };

  const handleCodiceFiscaleChange = (value) => {
    // Utilizza il valore nel componente genitore
    //console.log("stampo la mail",value);
    setCodiceFiscale(value.toUpperCase());
  };

  const handleTypePasswordChange = (value) => {
    // Utilizza il valore nel componente genitore
    //console.log("stampo la password",value);
    setPassword(value);
  };

  return (
    <div className="log-in-interno">
      <Logo></Logo>
      <div className="login-screen">
        <div className="typeforms-buttons">
          <div className="title-container">
            <h1 className="title">Log In</h1>
          </div>
          <div className="div">
            <div className="div">
              <TypeForm
                className="type-form-instance"
                label="Codice Fiscale"
                value={codiceFiscale}
                onChange={handleCodiceFiscaleChange}
              />
              <TypeForm
                className="type-form-instance"
                label="Password"
                isPassword={true}
                autoComplete="current-password"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                onChange={handleTypePasswordChange}
                value={password}
                override={
                  <IconInterfacesLock className="design-component-instance-node" />
                }
              />
            </div>
            <div className="other-typeform">
              {/*
              <div className="ricordami-check">
                <Checkbox className="design-component-instance-node" property1="checked" />
                <div className="text-wrapper">Ricordami</div>
              </div>*/}
              <div className="text-wrapper-2" onClick={forgetPassword}>
                Hai dimenticato la password?
              </div>
            </div>
          </div>
          <>
            <ErrorMessageInForm message={errorMessage} />
          </>
          <div className="buttons">
            <Button
              className="button-instance"
              property1="primary"
              text="Accedi"
              onClick={handleClickLoginButton}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
